import React, { useEffect, useState } from 'react'
import { BsFillTelephoneFill, BsTelephoneFill } from 'react-icons/bs'
import { FaEye } from 'react-icons/fa'
import { Modal } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import './ViewContact.css'
import { HiMailOpen } from 'react-icons/hi'
import { useCookies } from 'react-cookie'
import { decreaseContact } from '../../../Redux/features/User/userSlice'

function ContactDetails({ match, isConnected }) {
    const { user } = useSelector(state => state.user)
    const [showEmail, setShowEmail] = useState("show")
    const [showPhone, setShowPhone] = useState("show")
    const [email, setEmail] = useState("")
    const [mobile, setMobile] = useState("")
    const dispatch = useDispatch()
    //eslint-disable-next-line
    const [cookies, setCookie] = useCookies(['x-auth-token']);

    useEffect(() => {
        if (match?.privacy?.email === "hide") {
            setShowEmail("hide")
        } else if (match?.privacy?.email === "like" && !isConnected) {
            setShowEmail("like")
        } else if (match?.privacy?.email === "premium" && user?.userStatus.membership.membershipType === "Free") {
            setShowEmail("premium")
        } else if (match?.privacy?.email === "likeAndPremium" && ((user?.userStatus.membership.membershipType === "Free") || isConnected)) {
            setShowEmail("premium")
        } else if (match?.privacy?.email === "likeAndPremium" && ((user?.userStatus.membership.membershipType !== "Free") || !isConnected)) {
            setShowEmail("like")
        } else {
            setEmail(match?.email)
        }

        if (match?.privacy?.mobile === "hide") {
            setShowPhone("hide")
        } else if (match?.privacy?.mobile === "like" && !isConnected) {
            setShowPhone("like")
        } else if (match?.privacy?.mobile === "premium" && user?.userStatus.membership.membershipType === "Free") {
            setShowPhone("premium")
        } else if (match?.privacy?.mobile === "likeAndPremium" && ((user?.userStatus.membership.membershipType === "Free") || isConnected)) {
            setShowPhone("premium")
        } else if (match?.privacy?.mobile === "likeAndPremium" && ((user?.userStatus.membership.membershipType !== "Free") || !isConnected)) {
            setShowPhone("like")
        } else {
            setMobile(match?.mobile)
        }
        //eslint-disable-next-line
    }, [match, isConnected, user?.userStatus.membership.membershipType])
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = async () => {
        setShow(true)
        const content = {
            data: {
                email: "",
                mobile: "",
                id: match?._id
            },
            header: cookies['x-auth-token']
        }
        if (email) content.data.email = email
        if (mobile) content.data.mobile = mobile
        dispatch(decreaseContact(content))
    }
    return (
        <>
            <Modal show={show} onHide={handleClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Contact Card</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <div className="contact-name">You are viewing Contact Details of <span>{match?.firstName} {match?.lastName}</span></div>
                        {showEmail === "show" && <div className="email-link">
                            <HiMailOpen size={25} />
                            <Link to={`mailto:${match?.email}`}>
                                {match?.email}
                            </Link>
                        </div>}
                        {showPhone === "show" && <div className="phone-link">
                            <BsTelephoneFill size={25} />
                            <Link to={`tel:${match?.mobile}`}>
                                {match?.mobile}
                            </Link>
                        </div>}
                    </div>
                    <div className="contact-border"></div>
                    <div className='contact-bottom'>
                        <div><Link>Report Number</Link></div>
                        <div className="left-contact fw-bold">
                            Contact Views Left: <span className="text-danger">{user?.userStatus?.membershipDetails?.viewContacts}</span>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            <div className='d-flex'>
                <BsFillTelephoneFill className='match-detail-icon' />
                <div className='match-detail-title'>Contact Details</div>
            </div>
            <div className='match-detail-info'>
                {(showEmail === "show" || showPhone === "show") && <button onClick={() => handleShow()} className='view-contact-btn'>
                    <FaEye /> View Contact
                </button>}
                {(showEmail === "hide" && showPhone === "hide") && <button disabled className='view-contact-btn'>
                    <FaEye /> Contact Details Hidden
                </button>}
                {(showEmail === "premium" || showPhone === "premium") && <button disabled className='view-contact-btn'>
                    <FaEye /> Upgrade to Premium
                </button>}
                {(showEmail === "like" && showPhone === "like") && <button disabled className='view-contact-btn'>
                    <FaEye /> You Need to connect first
                </button>}
            </div>
        </>
    )
}

export default ContactDetails